import styled from 'styled-components';
import { Member } from 'api/MembersAPI';
import { AvatarStack } from 'ui/avatar/AvatarStack';
import { colors } from 'ui/theme';
import { User } from 'modules/graphql';

const EmptyAvatarMessage = styled.span`
  color: ${colors.textSecondary};
`;

type Props = {
  getMemberByUserId: (userId: string) => Member | undefined;
  getUserById: (id: string) => User | undefined;
  members: string[];
};

export const MembersTableCell = ({ getMemberByUserId, getUserById, members }: Props) => {
  if (members?.length < 1) {
    return <EmptyAvatarMessage>No members</EmptyAvatarMessage>;
  }

  const avatars = members.map((userId) => {
    const member = getMemberByUserId(userId);
    const user = getUserById(userId);

    return {
      firstName: member?.firstName || '',
      lastName: member?.lastName || '',
      imgSrc: user?.avatarUrl,
    };
  });

  return <AvatarStack avatars={avatars} hasTooltip />;
};
